import React from "react";
import { Suspense } from "react";
import { Skeleton } from "../components/common/skeleton";

const SuspenseSkeleton = () => (
  <div style={{ padding: "32px 24px", display: "flex", flexDirection: "column", gap: 20 }}>
    <Skeleton width="40%" height={28} borderRadius="8px" />
    <Skeleton width="60%" height={16} borderRadius="6px" />
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(280px, 100%), 1fr))", gap: 16, marginTop: 8 }}>
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Skeleton key={i} width="100%" height={160} borderRadius="12px" />
      ))}
    </div>
  </div>
);

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <Suspense fallback={<SuspenseSkeleton />}>{children}</Suspense>;

export default SuspenseWrapper;
